<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span><br>
            <span class="font-weight-bold mr-2" style="color:red;">請確實核對客戶資料並協助變更、回報，以確保客戶權益</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button> 
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <Info-Adjustment-Table
          :height="data_table_height"
          @update="updateSelection"
          @comment-modal="commentModal"
          @jump-to-customer="jumpToCustomer"
          @Info-Adjustment-Detail="InfoAdjustmentDetail"
          @Visit-For-InfoAJ="VisitForInfoAJ"
          @get-Data="getData"
          :table-data="tableData"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline">
          </div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <comment-modal
      :open="commentModalOpen"
      :comment="comment"
      @close="panelClose('commentModalOpen')"
    />

    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <Info-Adjustment-Detail
      :open="InfoAdjustmentDetailModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('InfoAdjustmentDetailModalOpen')"
    />

    <Visit-For-InfoAJ
      :open="VisitForInfoAJModalOpen"
      :record="currentRecord2"
      :cat-info="categoryInfo"
      @close="panelClose('VisitForInfoAJModalOpen')"
      @nextstep="nextstep"
    />

    <NonVisit
      :open="NonVisitModalOpen"
      :record="currentRecord2"
      :cat-info="categoryInfo"
      @close="CloseNonVisit"
      @previous="previousToVisit2"
    />

    <Already-Visit
      :open="AlreadyVisitModalOpen"
      :record="currentRecord2"
      :cat-info="categoryInfo"
      @close="CloseAlreadyVisit"
      @previous="previousToVisit"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import InfoAdjustmentTable from "../DataTable/InfoAdjustmentTable";
import InfoAdjustmentDetail from "../InfoAdjustmentDetail";
import VisitForInfoAJ from "@/desktop/components/VisitForInfoAJModal";
import NonVisit from "@/desktop/components/NonVisitModal";
import AlreadyVisit from "@/desktop/components/AlreadyVisitModal";
import CommentModal from "../CommentModal";
import SatisfactionModal from "../SatisfactionModal";
import {
  getInfoAdjustment,
  getCategoryDetail,
  isSatisfactionSurveyFinish
} from "@/service";
import { downloadFile_m0 } from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "InfoAdjustment",
  mixins: [commonMixin],
  components: {
    InfoAdjustmentTable,
    CommentModal,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    InfoAdjustmentDetail,
    VisitForInfoAJ,
    NonVisit,
    AlreadyVisit
  },
  props: {
    status: String
  },
  computed: {},
  data() {
    //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      commentModalOpen: false,
      satisfactionModalOpen: false,
      comment: "",
      data_table_height: 0,
      NonVisitReasonModalOpen: false,
      InfoAdjustmentDetailModalOpen: false,
      VisitForInfoAJModalOpen: false,
      NonVisitModalOpen: false,
      AlreadyVisitModalOpen: false,
      categoryInfo: {},
      currentRecord: {},
      currentRecord2: {},
      edit_access_index: 0,
      edit_access_name: "",
      info: {},
      sortOrder: 0
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    commentModal(comment) {
      this.comment = comment;
      this.panelOpen("commentModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    jumpToCustomer(index) {
      // 導頁到客戶資料
      this.updateCustID(index);
      localStorage.CustID = index;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    formatVIP(val) {
      //  轉換 VIP code
      const filterData = [
        { name: "黃金", code: "5" },
        { name: "白金", code: "6" },
        { name: "鑽石", code: "7" }
      ];
      let reData = "";
      filterData.forEach(item => {
        if (val == item.code) {
          reData = item.name;
        }
      });
      return reData;
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    initWarranty() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      // 取得列表資料
      this.isLoading = true;
      this.getData(0);
      // 取得專區資訊
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    InfoAdjustmentDetail(record) {
      this.currentRecord = record;
      this.panelOpen("InfoAdjustmentDetailModalOpen");
    },
    VisitForInfoAJ(record) {
      this.currentRecord2 = record;
      this.panelOpen("VisitForInfoAJModalOpen");
    },
    nextstep(type) {
      this.panelClose("VisitForInfoAJModalOpen");
      if (type == "1") {
        this.panelOpen("AlreadyVisitModalOpen");
      } else if (type == "0") {
        this.panelOpen("NonVisitModalOpen");
      } else {
        this.panelClose("VisitForInfoAJModalOpen");
      }
    },
    NonVisit(record) {
      this.currentRecord = record;
      this.panelOpen("NonVisitModalOpen");
    },
    CloseNonVisit() {
      this.panelClose("NonVisitModalOpen");
      this.initWarranty();
    },
    AlreadyVisit(record) {
      this.currentRecord = record;
      this.panelOpen("AlreadyVisitModalOpen");
    },
    CloseAlreadyVisit() {
      this.panelClose("AlreadyVisitModalOpen");
      this.initWarranty();
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    },
    previousToVisit() {
      this.panelClose("AlreadyVisitModalOpen");
      this.panelOpen("VisitForInfoAJModalOpen");
    },
    previousToVisit2() {
      this.panelClose("NonVisitModalOpen");
      this.panelOpen("VisitForInfoAJModalOpen");
    },
    getData(value) {
      this.sortOrder = value;
      getInfoAdjustment(this.$store.state.userInfo.id, this.sortOrder).then(
        result => {
          this.isLoading = false;
          if (result.header && result.header.status === "200") {
            this.tableData = result.body.lists.map(item => {
              return {
                name: item.name || "", //客戶姓名
                index: item.customer_id || "",
                id: item.customer_id || "", //客戶ID
                sex: Number(item.customer_id[1]), //性別
                vip_lv: item.vip_lvl, //顯示VIP
                vip_lvl: this.formatVIP(item.vip_lvl), //VIP等級
                mobl_adj_item_name: item.mobl_adj_item_name || "", //項目
                mail_adj_item_name: item.mail_adj_item_name || "", //項目
                addr_adj_item_name: item.addr_adj_item_name || "", //項目
                mobl_adj_item_code: item.mobl_adj_item_code || "", //項目代碼
                mail_adj_item_code: item.mail_adj_item_code || "", //項目代碼
                addr_adj_item_code: item.addr_adj_item_code || "", //項目代碼
                error_email: item.error_email || "", //明細查詢(錯的email)
                error_mobl: item.error_mobl || "", //明細查詢(錯的手機)
                error_addr: item.error_addr || "", //明細查詢(錯的地址)
                multi_email: item.multi_email || "", //明細查詢(共用的email)
                multi_mobl: item.multi_mobl || "", //明細查詢(共用的手機)
                multi_addr: item.multi_addr || "", //明細查詢(共用的地址)
                mobl_eft_date: item.mobl_eft_date || "", //變更日
                email_eft_date: item.email_eft_date || "", //變更日
                addr_eft_date: item.addr_eft_date || "", //變更日
                reply_date: item.reply_date || "", //回報日
                is_trn: item.is_trn == "Y" ? "已開通" : "未申辦", //是否同意保單線上服務
                visit_Reply_email: item.visit_reply_email || "",
                visit_Reply_mobl: item.visit_reply_mobl || "",
                visit_Reply_addr: item.visit_reply_addr || "",
                is_exist: item.is_exist || false, //判斷是否有客戶資料
                is_done:
                  item.reply_date ||
                  item.mobl_eft_date ||
                  item.email_eft_date ||
                  item.addr_eft_date
                    ? "已完成"
                    : "未完成",
                visit_memo: item.visit_memo || "",
                unvisit_memo: item.unvisit_memo || "",
                unvisit_reply: item.unvisit_reply || "",
                remind_msg: item.remind_msg || "" //提醒事項
              };
            });
            this.registerHanlink(); // for hard word
          }
        }
      );
    }
  },
  mounted() {
    // 資料初始化
    this.initWarranty();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
